import type {RoadmapItem} from './roadmapData';

export type RoadmapTab =
  | 'all'
  | 'launches'
  | 'roadmap'
  | 'dependencies'
  | 'rollup'
  | 'allocations'
  | 'audit';
export type RoadmapViewMode = 'table' | 'gantt';
export type RoadmapSortOrder = 'end_date' | 'status' | 'owner';
export type RoadmapGrouping = `depth:${number}` | 'all';
export type AuditInconsistencyIssueType = 'past_end_date' | 'past_start_date' | 'missing_end_date';

export interface AuditWorkstreamInitiative {
  key: string;
  title: string;
  devWeeks: number;
  totalEstHc: number;
  cautionReason: string | null;
}

export interface AuditWorkstreamNode {
  key: string;
  title: string;
  issueType: string;
  devWeeks: number;
  totalEstHc: number;
  children: AuditWorkstreamNode[];
  initiatives: AuditWorkstreamInitiative[];
}

export interface AuditInvestmentNode {
  key: string;
  title: string;
  categories: Record<string, number>;
  totalDevWeeks: number;
  children: AuditInvestmentNode[];
}

export interface LaunchTableRow {
  id: string;
  item: RoadmapItem;
}

export interface RoadmapHierarchyNode {
  key: string;
  title: string;
  issueType: string;
  workstreamId: number | null;
  workstreamArchived: boolean | null;
  children: RoadmapHierarchyNode[];
  initiatives: RoadmapItem[];
}

export type DashboardProgressBucket =
  | 'total'
  | 'completed'
  | 'onTrack'
  | 'atRiskDelayed'
  | 'notStarted'
  | 'cancelled';

export interface DashboardProgress {
  total: number;
  completed: number;
  onTrack: number;
  atRiskDelayed: number;
  notStarted: number;
  cancelled: number;
}

export const ROADMAP_QUERY_KEY = ['workstreams-roadmap-static'];

export const UNCATEGORIZED_INVESTMENT_CATEGORY = 'Uncategorized';

export const INVESTMENT_CATEGORY_ORDER = [
  'KTLO',
  'Foundation',
  'Near Term / Incremental',
  'Long Term / Speculative',
  UNCATEGORIZED_INVESTMENT_CATEGORY,
] as const;

export const INVESTMENT_CATEGORY_SHORT_LABELS: Record<string, string> = {
  KTLO: 'KTLO',
  Foundation: 'Foundation',
  'Near Term / Incremental': 'Near Term',
  'Long Term / Speculative': 'Long Term',
  Uncategorized: 'Uncategorized',
};

export const ROADMAP_STATUS_ORDER = [
  'At Risk',
  'Delayed',
  'Blocked',
  'On Hold',
  'In Progress',
  'On Track',
  'Backlog',
  'To Do',
  'Done',
  'Completed',
  'Cancelled',
  'Deprioritized',
] as const;
